import { useEffect } from "react";
import { gql, useQuery } from "@apollo/client";
import { useStore } from "../store";

const CLOUD_STATUS = gql`
  query CloudStatusQ {
    cloudStatus { mode tokenValid tokenDaysLeft syncPending lastChecked nodesOffline }
  }
`;

export default function CloudStatusPoll() {
  const setCloudStatus = useStore(s => s.setCloudStatus);
  const { data } = useQuery(CLOUD_STATUS, { pollInterval: 5000, fetchPolicy: "network-only" });
  useEffect(() => {
    if (!data?.cloudStatus) return;
    const { mode, tokenValid, tokenDaysLeft, syncPending } = data.cloudStatus;
    setCloudStatus({ mode, tokenValid, tokenDaysLeft, syncPending });
  }, [data, setCloudStatus]);
  return null;
}
